var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 78C60.9868 78 78 60.9868 78 40C78 19.0132 60.9868 2 40 2C19.0132 2 2 19.0132 2 40C2 60.9868 19.0132 78 40 78Z",
    fill: "#77FF73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C32.0888 80 24.3552 77.6541 17.7772 73.2588C11.1992 68.8636 6.07235 62.6164 3.04485 55.3074C0.0173426 47.9983 -0.774806 39.9557 0.768603 32.1964C2.31201 24.4372 6.12165 17.3099 11.7157 11.7158C17.3098 6.12165 24.4372 2.31202 32.1964 0.768607C39.9556 -0.774802 47.9983 0.0173314 55.3073 3.04484C62.6164 6.07234 68.8635 11.1992 73.2588 17.7772C77.6541 24.3552 80 32.0888 80 40C80 50.6087 75.7858 60.7828 68.2843 68.2843C60.7829 75.7858 50.6087 80 40 80ZM40 4.00002C32.8799 4.00002 25.9197 6.11138 19.9995 10.0671C14.0793 14.0228 9.4651 19.6453 6.74034 26.2234C4.01559 32.8016 3.30269 40.04 4.69176 47.0233C6.08083 54.0066 9.50949 60.4212 14.5442 65.4559C19.5789 70.4906 25.9934 73.9192 32.9768 75.3083C39.9601 76.6974 47.1985 75.9844 53.7766 73.2597C60.3548 70.5349 65.9772 65.9207 69.9329 60.0006C73.8887 54.0804 76 47.1202 76 40C76 30.4522 72.2072 21.2955 65.4559 14.5442C58.7046 7.79287 49.5478 4.00002 40 4.00002Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.92 26.13L36.81 46.34L33.45 39.6H26.71L33.45 53.07H40.18L53.65 26.13H46.92Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrect);
export default __webpack_public_path__ + "static/media/icon-correct.68307bd5fb3c71edc308c30c9fc8376f.svg";
export { ForwardRef as ReactComponent };